import React, { Component } from "react";
import { I18n } from "react-redux-i18n";
import cx from "classnames";
import { List, AutoSizer } from "react-virtualized";
import Icon from "@alboompro/boom-components/general/icon";

import { getIcons, chunk } from "./helpers";
import { IconRow } from "./styles";

// Max items displayed per row in the modal
const MAX_ITEMS_PER_ROW = 8;

class Icons extends Component {
  constructor(props) {
    super(props);
    this.icons = null;
    this.state = {
      icons: null,
      results: null
    };
  }

  componentDidMount() {
    getIcons()
      .then(icons => {
        this.icons = icons;
        this.setState({ icons: chunk(icons, MAX_ITEMS_PER_ROW) });
      })
      .catch(err => {
        console.log(err);
      });
  }

  componentWillReceiveProps(nextProps) {
    const { searchTerm } = this.props;
    if (nextProps.searchTerm !== searchTerm) {
      this.search(nextProps.searchTerm);
    }
  }

  /**
   * Filter the icons dataset in order to retrieve
   * any entries which the labels, the translated labels or
   * the search terms includes the term being searched.
   *
   * @param {String} searchTerm term which will be searched
   */
  search = searchTerm => {
    const term = searchTerm.toLowerCase();
    const results = this.icons.filter(icon => {
      const inLabel = String(icon.label)
        .toLowerCase()
        .includes(term);
      const inTranslatedLabels = Object.values(icon.labels).some(i =>
        String(i)
          .toLowerCase()
          .includes(term)
      );
      const inTerms = icon.terms.some(i =>
        String(i)
          .toLowerCase()
          .includes(term)
      );
      return inLabel || inTranslatedLabels || inTerms;
    });
    this.setState({
      icons: chunk(results, MAX_ITEMS_PER_ROW),
      results: results.length
    });
  };

  /**
   * Render a row containing selectable icons
   */
  renderRow = ({ index, key, style }) => {
    const { icons } = this.state;
    const { handleClick, selected } = this.props;
    const row = icons[index];
    return (
      <IconRow key={key} style={style}>
        {row.map(icon => {
          const isActive = selected ? selected === icon.code : false;
          const iconClasses = cx("icon-container", {
            active: isActive
          });
          return (
            <div
              key={`${icon.label}-${icon.code}`}
              className={iconClasses}
              onClick={() => {
                handleClick(icon.code);
              }}
            >
              {isActive && (
                <div className="active-icon">
                  <Icon
                    kind="bold"
                    group="interface-essential"
                    category="form-validation"
                    file="check.svg"
                    size="12"
                    color="#fff"
                  />
                </div>
              )}
              <i className={icon.code} />
            </div>
          );
        })}
      </IconRow>
    );
  };

  render() {
    const { icons, results } = this.state;
    const { selected, searchTerm } = this.props;
    if (!icons) return null;

    const rowHeight = 110;

    return searchTerm !== "" && !icons.length ? (
      <div className="empty">
        <h1> {I18n.t("editPanel.iconPicker.noResults")}</h1>
      </div>
    ) : (
      <AutoSizer>
        {({ width, height }) => {
          return (
            <List
              className="icon-list"
              width={width}
              height={height}
              rowHeight={rowHeight}
              rowRenderer={this.renderRow}
              rowCount={icons.length}
              overscanRowCount={3}
              results={results}
              selected={selected}
            />
          );
        }}
      </AutoSizer>
    );
  }
}

export default Icons;
